import React, { useState } from 'react';
import { CTAButton } from './CTAButton';
const placeholderImg = 'https://digitalearnpro.com/wp-content/uploads/2025/09/20250930_1424_Espacio-para-tu-Imagen_simple_compose_01k6dtcpvgec9s48a98jsekbnr.png';
const faqs = [{
  question: '📥 ¿Cómo accedo a las recetas?',
  answer: <p data-id="element-72">
        Una vez realizado el pago, recibirás un{' '}
        <strong data-id="element-73">link para acceder inmediatamente</strong>.
      </p>
}, {
  question: '📦 ¿Es un producto físico?',
  answer: <p data-id="element-74">
        No, es un <strong data-id="element-75">producto digital</strong>, lo recibirás por{' '}
        <strong data-id="element-76">correo electrónico</strong>.
      </p>
}, {
  question: '🍳 ¿Puedo usar las recetas si soy principiante en cocina?',
  answer: <p data-id="element-77">
        <strong data-id="element-78">¡Sí!</strong> Las recetas están diseñadas para{' '}
        <strong data-id="element-79">todos los niveles</strong>.
      </p>
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-cream pt-[40px] pb-[40px] px-[15px] relative" data-id="element-80">
      <div className="max-w-[500px] mx-auto px-[15px]" data-id="element-81">
        <h2 className="text-[26px] text-center mb-8 leading-[1.2] font-bold text-black heading-underline" data-id="element-82">
          🤔 Preguntas Frecuentes (FAQ)
        </h2>

        <div className="mb-8" data-id="element-83">
          {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <div key={idx} className="mb-4 rounded-lg overflow-hidden shadow-[0_4px_10px_rgba(0,0,0,0.05)] border border-[#eee] bg-white" data-id="element-84">
                <div className="p-[16px] font-semibold text-[16px] cursor-pointer relative flex justify-between items-center text-black" onClick={() => toggleFAQ(idx)} data-id="element-85">
                  <span className="pr-4" data-id="element-86">{faq.question}</span>
                  <span className="text-[22px] text-primary transition-all duration-400 ease-[cubic-bezier(0.25,0.8,0.25,1)] shrink-0" data-id="element-87">
                    {isOpen ? '-' : '+'}
                  </span>
                </div>

                <div className="px-[16px] overflow-hidden transition-all duration-300 ease-out text-[15px] text-dark-gray" style={{
              maxHeight: isOpen ? '500px' : '0'
            }} data-id="element-88">
                  <div className="py-[16px] leading-[1.6] border-t border-[#eee]" data-id="element-89">
                    {faq.answer}
                  </div>
                </div>
              </div>;
        })}
        </div>

        <CTAButton href="https://kleoyshop.com/cart/add?id=52708878745928&quantity=1" className="underline" data-id="element-90">
          ¡Consigue acceso ahora y empieza a cocinar!
        </CTAButton>
      </div>
    </section>;
}